import { render, staticRenderFns } from "./context_menu_item.vue?vue&type=template&id=7cf8bd10&scoped=true&"
import script from "./context_menu_item.vue?vue&type=script&setup=true&lang=ts&"
export * from "./context_menu_item.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./context_menu_item.vue?vue&type=style&index=0&id=7cf8bd10&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf8bd10",
  null
  
)

export default component.exports